module.exports = __webpack_public_path__ + "media/images/loghi/google-play-badge-ffbc0647505e59c5e2c76216d8db30a2.svg";